export function checksum(str) {
    var hash = 0;
    var strlen = str.length;
    var i, c;
    if (strlen === 0) {
        return hash;
    }
    for (i = 0; i < strlen; i++) {
        c = str.charCodeAt(i);
        hash = (hash << 5) - hash + c;
        hash &= hash;
    }
    return hash >>> 0;
}
//# sourceMappingURL=checksum.js.map